import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { BottomSheet } from '@/components/ui/BottomSheet';
import { Button } from '@/components/ui/Button';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface EsConfirmProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmText: string;
  cancelText: string;
  variant?: 'danger' | 'warning' | 'default';
  loading?: boolean;
  onConfirm: () => void;
}

/** Confirm dialog on desktop, bottom sheet on phones. */
export const EsConfirm = ({
  open,
  onOpenChange,
  title,
  description,
  confirmText,
  cancelText,
  variant = 'default',
  loading = false,
  onConfirm,
}: EsConfirmProps) => {
  const isMobile = useMediaQuery('(max-width: 767px)');

  if (!isMobile) {
    return (
      <ConfirmDialog
        open={open}
        onOpenChange={onOpenChange}
        title={title}
        description={description}
        confirmText={confirmText}
        cancelText={cancelText}
        variant={variant}
        loading={loading}
        closeOnConfirm={false}
        onConfirm={onConfirm}
      />
    );
  }

  return (
    <BottomSheet open={open} onOpenChange={(next) => (loading ? undefined : onOpenChange(next))}>
      <div className="p-5 space-y-4">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <p className="text-sm text-gray-600">{description}</p>
        <div className="flex flex-col gap-2 pt-1">
          <Button variant={variant === 'danger' ? 'danger' : 'primary'} size="lg" loading={loading} onClick={onConfirm}>
            {confirmText}
          </Button>
          <Button variant="outline" size="lg" disabled={loading} onClick={() => onOpenChange(false)}>
            {cancelText}
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};
